import { Zap, Clock, TrendingUp, Heart } from "lucide-react";

const ITEMS = [
  { icon: Zap, title: "Hook in 2 Sek.", body: "Wir schneiden für Retention – jede Sekunde zählt." },
  { icon: TrendingUp, title: "Conversion First", body: "Content der nicht nur Views, sondern Umsatz generiert." },
  { icon: Clock, title: "7–14 Tage", body: "Schnelle Lieferzeit ohne Qualitätsverlust." },
  { icon: Heart, title: "Zufriedenheits-Garantie", body: "2 Überarbeitungen inklusive. Bis es sitzt." },
];

export default function TrustBar() {
  return (
    <section
      className="border-b border-white/10 bg-mfp-surface/40"
      data-testid="trust-section"
    >
      <div className="max-w-6xl mx-auto px-4 md:px-8 py-10 md:py-16">
        <div className="grid grid-cols-2 md:grid-cols-4 gap-4 md:gap-6">
          {ITEMS.map((it, i) => (
            <div
              key={i}
              className="border border-white/10 p-4 md:p-6 flex flex-col gap-3 bg-black/30"
              data-testid={`trust-item-${i}`}
            >
              <div className="h-10 w-10 bg-mfp-gold flex items-center justify-center">
                <it.icon className="h-5 w-5 text-white" />
              </div>
              <div className="font-display uppercase text-base md:text-lg leading-tight">
                {it.title}
              </div>
              <p className="text-xs md:text-sm text-mfp-muted leading-relaxed">{it.body}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
